import React, { useState } from "react";
import NotifBadged from "../header-elements/NotifBadged";
import DropDownElement from "../elements/DropDownElement";
import { useUserContext } from "../../context/UserContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import NotifBox from "./NotifBox";
import { useAxiosInstance } from "../../api/axios";
import { USER_LIST_NOTIFICATIONS } from "../../api/apiClient";

type dataProps = {
  title: string;
  message: string;
  date: string;
  time: string;
  created_at: string;
  is_read: boolean;
  notification_type:
    | "NORMAL_NOTIFICATION"
    | "SUCCESS_NOTIFICATION"
    | "FAIL_NOTIFICATION";
  notification_uid: string;
};

const HeaderCreditor: React.FC = () => {
  const axiosHook = useAxiosInstance();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [data, setData] = useState<dataProps[]>([]);
  const { userData, setUserData } = useUserContext();

  const old_access_token = localStorage.getItem("old_access_token");

  const logOut = () => {
    Swal.fire({
      title: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#477CD1",
      cancelButtonColor: "white",
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      customClass: {
        confirmButton: "my-confirm-button",
        cancelButton: "my-cancel-button",
        icon: "no-border",
        title: "title-padding",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (!old_access_token) {
          localStorage.clear();
          document.cookie.split(";").forEach((cookie) => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          });
          setUserData(null);
          Swal.fire({
            title: "از حساب کاربری خود خارج شدید",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          navigate("/");
        } else {
          old_access_token &&
            localStorage.setItem("access_token", old_access_token);

          localStorage.removeItem("old_access_token");
          navigate("/fa/admin-dashboard");
        }
      }
    });
  };

  const getNotifData = () => {
    setIsLoading(true);
    axiosHook
      .get(USER_LIST_NOTIFICATIONS("", 1, 4, ""))
      .then((res) => {
        setIsLoading(false);
        setData(res.data.data.results);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const OpenNotifPage = () => {
    setIsOpen(true);
    getNotifData();
  };

  return (
    <>
      <header className="h-[90px] flex items-center justify-between md:justify-around max-w-[2800px] md:pr-24 px-3">
        <nav className="invisible col-span-2 w-fit  ">
          <ul className="flex items-center justify-center gap-10 ">
            <li className="whitespace-nowrap">
              <a href="/fa/user-auth">درخواست اعتبار</a>
            </li>
            <li className="whitespace-nowrap">
              <a href="/shops">فروشگاه‌ها</a>
            </li>
            <li className="whitespace-nowrap">
              <a href="/blogs">بلاگ‌ها</a>
            </li>
          </ul>
        </nav>
        <div className="flex items-center gap-4 ml-2">
          <div
            className="flex items-center gap-12 mr-2 cursor-pointer relative"
            onClick={() => OpenNotifPage()}
          >
            <NotifBox
              redirect_route="/fa/creditor-dashboard/notifUser"
              isLoading={isLoading}
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              data={data}
            />
            <NotifBadged
              src="/icons/notif.svg"
              spanContent={userData?.notification_count}
            />
          </div>

          <DropDownElement logOut={logOut} />
        </div>
      </header>
    </>
  );
};

export default HeaderCreditor;
